<template lang="pug">
    el-alert.mb-3.px-4.alerta-usuario-laudos(
        v-if='alertaLaudos',
        :title='$t("mensagens.home.usuarioLaudos.alerta")',
        type='warning',
        :closable='true',
        show-icon,
        @close='$emit("closeAlerta")'
    )
</template>
<script>
export default {
    name: 'AlertaUsuaioLaudos',

    props: {
        alertaLaudos: {
            type: Boolean,
            required: true
        }
    }
};
</script>
